import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BAPhilosophyCoursePage: React.FC = () => {
  const courseData = {
    title: "B.A. Philosophy",
    shortName: "B.A. Philosophy",
    duration: "3 years",
    description: "Study of fundamental questions about existence, knowledge, values, and reason",
    overview: "Bachelor of Arts in Philosophy is a 3-year undergraduate program that explores fundamental questions about human existence, knowledge, ethics, and reality. This course develops critical thinking, logical reasoning, and analytical skills through the study of classical and contemporary philosophical texts, preparing students for careers in academics, law, writing, and public service.",
    eligibility: [
      "10+2 in any stream",
      "Minimum 50% marks in 12th standard",
      "Strong analytical and reasoning skills",
      "Interest in abstract thinking and debate"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Introduction to Philosophy",
          "Logic and Critical Thinking",
          "Ancient Philosophy",
          "General English",
          "Tamil Literature",
          "Psychology (Optional)"
        ]
      },
      {
        year: 2,
        subjects: [
          "Medieval Philosophy",
          "Modern Philosophy",
          "Ethics and Moral Philosophy",
          "Political Philosophy",
          "Philosophy of Religion",
          "Indian Philosophy"
        ]
      },
      {
        year: 3,
        subjects: [
          "Contemporary Philosophy",
          "Metaphysics and Epistemology",
          "Philosophy of Mind",
          "Social Philosophy",
          "Applied Ethics",
          "Research Project"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Philosophy Professor",
        "Research Scholar",
        "Content Writer",
        "Journalist",
        "Legal Advisor",
        "Ethics Consultant",
        "Policy Analyst",
        "Civil Services Officer",
        "Author/Writer",
        "Counselor"
      ],
      industries: [
        "Educational Institutions",
        "Research Organizations",
        "Media and Publishing",
        "Government Departments",
        "Legal Firms",
        "NGOs and Think Tanks",
        "Corporate Ethics Committees",
        "International Organizations",
        "Religious Institutions",
        "Consulting Firms"
      ],
      averageSalary: "₹3-7 LPA (Fresher), ₹10-25 LPA (Experienced)",
      topRecruiters: [
        "Universities and Colleges",
        "Research Institutes",
        "Publishing Houses",
        "Government Organizations",
        "Law Firms",
        "Media Companies"
      ]
    },

    admissionProcess: [
      "Merit-based admission on 12th marks",
      "Entrance tests in some universities",
      "Interview and group discussion",
      "Online application process",
      "Document verification"
    ],

    topColleges: [
      {
        name: "University of Madras",
        location: "Chennai",
        fees: "₹25,000",
        ranking: "State University"
      },
      {
        name: "Loyola College",
        location: "Chennai",
        fees: "₹45,000",
        ranking: "NIRF Ranking: 15"
      },
      {
        name: "Presidency College",
        location: "Chennai",
        fees: "₹20,000",
        ranking: "Government College"
      },
      {
        name: "Annamalai University",
        location: "Chidambaram",
        fees: "₹30,000",
        ranking: "State University"
      }
    ],

    skills: [
      "Critical Thinking",
      "Logical Reasoning",
      "Analytical Writing",
      "Debate and Discussion",
      "Research Methods",
      "Abstract Thinking",
      "Problem Solving",
      "Communication Skills",
      "Ethical Reasoning",
      "Comparative Analysis"
    ],

    futureScope: "Growing demand for ethical consultants, policy analysts, and critical thinkers in corporate world, artificial intelligence ethics, bioethics, and environmental policy making.",

    faqs: [
      {
        question: "What practical career options exist for philosophy graduates?",
        answer: "Philosophy graduates can work in law, journalism, civil services, corporate ethics, policy making, teaching, and research with strong analytical and communication skills."
      },
      {
        question: "Is philosophy only academic or does it have real-world applications?",
        answer: "Philosophy has significant real-world applications in ethics, policy making, law, business decision-making, and technology ethics, especially in AI and bioethics."
      },
      {
        question: "Can philosophy graduates pursue law or MBA?",
        answer: "Yes, philosophy provides excellent preparation for law school and MBA programs due to strong analytical, writing, and reasoning skills developed in the course."
      },
      {
        question: "What higher education options are available?",
        answer: "Students can pursue M.A. Philosophy, M.Phil., Ph.D., law degrees, MBA, or interdisciplinary programs in ethics, political science, or cognitive science."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BAPhilosophyCoursePage;
